import React, { useState } from "react";
import { cognitoLogin } from "../helpers/cognitoLogin";
import { apiGet } from "../api/api";

export default function CredencialesTest() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [idToken, setIdToken] = useState(localStorage.getItem("idToken") || "");
  const [output, setOutput] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleLogin() {
    setLoading(true);
    setOutput(null);
    try {
      const r = await cognitoLogin(username.trim(), password);
      setIdToken(r.idToken);
      localStorage.setItem("idToken", r.idToken);
      setOutput({ ok: true, message: "Login OK" });
    } catch (e) {
      setOutput({ ok: false, error: e?.message || String(e) });
    } finally {
      setLoading(false);
    }
  }

  async function testCredenciales() {
    setLoading(true);
    setOutput(null);
    try {
      const data = await apiGet("/credenciales", idToken);
      setOutput(data);
    } catch (e) {
      setOutput({ ok: false, error: e?.message || String(e) });
    } finally {
      setLoading(false);
    }
  }

  function logout() {
    setIdToken("");
    localStorage.removeItem("idToken");
    setOutput({ ok: true, message: "Token borrado" });
  }

  return (
    <div style={{ maxWidth: 520, margin: "24px auto", fontFamily: "system-ui" }}>
      <h2>Login Cognito (DEV) + Test /credenciales</h2>

      <div style={{ display: "grid", gap: 8 }}>
        <input
          placeholder="usuario (email)"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          placeholder="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button onClick={handleLogin} disabled={loading}>
          {loading ? "..." : "Login"}
        </button>

        <button onClick={testCredenciales} disabled={loading || !idToken}>
          Probar GET /credenciales
        </button>

        <button onClick={logout} disabled={loading}>
          Cerrar sesión (borrar token)
        </button>

        <small>Estado token: {idToken ? "✅ Guardado" : "❌ No hay token"}</small>
      </div>

      <pre style={{ marginTop: 16, padding: 12, background: "#111", color: "#0f0", overflow: "auto" }}>
        {JSON.stringify(output, null, 2)}
      </pre>
    </div>
  );
}
